export const getClusterletConnections = (state) => {
    return state.constructs.clusterletConnections;
}

export const checkValidConnection = payload  => {

    const { src, dst, smConnections, clusterlets } = payload;

    if(src === dst) return false

    const srcClusterlet = clusterlets.find(item => item._id === src);
    const dstClusterelt = clusterlets.find(item => item._id === dst);

    const hasSpecialType = (cl) => cl && cl.subType !== undefined && cl.type === 1;

    if (hasSpecialType(srcClusterlet) || hasSpecialType(dstClusterelt)) {
      return true;
    }

    const validConnections =  smConnections.filter(connection => {
        if((connection.source === src || connection.target === src) && (connection.source === dst||connection.target === dst)) return connection
    });

    if(validConnections.length > 0) return true;

    else return false
}